<template>
  <div>
    <footer class="main-footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <small>
              {{$t('footer.footerText')}}
            </small>
          </div>
        </div>
      </div>
    </footer>

  </div>
</template>
<script>

export default {
  name: 'footer1',

  data() {
    return {

    }
  },
  methods: {

  }
}

</script>
